import styled from 'styled-components';
import {
  backgroundColorTransparentButton,
  colorTransparentButton,
} from '../../../config/Colors/Ligth';

export const Container = styled.button`
  background: ${backgroundColorTransparentButton};
  color: ${colorTransparentButton};
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  border: none;
  width: auto;
  padding: 10px 10px;
  border-radius: 4px;
  transition: all 200ms;

  &:hover {
    filter: brightness(50%);
  }
`;
